<script lang="ts" generics="TValues, TValue">
    import type { Field, Form } from '@jmvdevelop/svelte-form';
    import { melt, createDialog } from '@melt-ui/svelte';
    import { cx } from '$lib/utils/cx';
    import SubmitButton from '$components/Form/SubmitButton.svelte';
    import Spinner from '$components/Spinner/Spinner.svelte';
    import * as t from '$trans';
    import { getContainer } from '$components/Context/ContainerContext';

    const { lang } = getContainer();
    export let form: Form<TValues, string>;
    export let queryField: Field<TValues, string | null>;
    export let itemField: Field<TValues, TValue | null> | null = null;

    export let label: string;
    export let placeholder: string;

    export let withSearch: boolean;

    export let dialog: ReturnType<typeof createDialog>;
    const {
        elements: { trigger },
    } = dialog;

    const q = form.stores().fieldValue(queryField);

    function clear() {
        form.dispatch(form.actions().changeValue('', queryField));
        if (itemField != null) {
            form.dispatch(form.actions().changeValue(null, itemField));
        }
    }
</script>

<div class="flex items-center">
    <button
        use:melt={$trigger}
        class={cx(
            'btn-reset',
            'w-full',
            'flex flex-col gap-[2px]',
            'text-gray-800',
            'px-[20px] py-[16px]',
            'text-left',
        )}
    >
        <span class={cx('font-bold', 'leading-[120%]')}>{label}</span>
        {#if ($q ?? '').trim() === ''}
            <span class="opacity-50 leading-[18px] line-clamp-1">{placeholder}</span>
        {:else}
            <span class="leading-[18px] line-clamp-1">{($q ?? '').trim()}</span>
        {/if}
    </button>

    <div class="pr-[20px] flex items-center gap-2">
        {#if ($q ?? '').trim() !== ''}
            <button
                type="button"
                aria-label="Clear"
                on:click|preventDefault={clear}
                class="btn-reset rounded-full bg-gray-400 hover:opacity-50 size-[20px] text-white flex items-center justify-center"
            >
                <i class="tnp tnp-cross text-10" aria-hidden={true} />
            </button>
        {/if}

        {#if withSearch}
            <SubmitButton
                {form}
                class="btn-leo btn-leo-primary rounded-full size-[45px]"
                ariaLabel={t.ui.search({}, $lang)}
            >
                <svelte:fragment slot="loading">
                    <Spinner size="xs" />
                </svelte:fragment>
                <i class="fa fa-search" aria-hidden="true"></i>
            </SubmitButton>
        {/if}
    </div>
</div>
